import { AllReferrals } from "./AllReferrals";
import { ReferUrl } from "./ReferUrl";
import { TotalEarning } from "./TotalEarning";

export function Referral() {

    const children = {
        allReferrals: AllReferrals(),
        referUrl: ReferUrl(),
        totalEarning: TotalEarning(),
    }

    function render() {
        return /*html*/`
        <div id="vertical-tab-myaccount-refer-and-earn" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-myaccount-refer-and-earn">
    <div class="space-y-4">
        <!-- Total earning -->
        ${children.totalEarning.render()}
        <!-- End Total earning -->

        <!-- User Refer Url -->
        ${children.referUrl.render()}
        <!-- End User Refer Url -->

        <!-- Referrals list -->
        ${children.allReferrals.render()}
        <!-- End Referrals list -->
    </div>
</div>
`;
    }
    return { render, children };
}